export enum CertificationSectionStatus {
  SECTION_INTRO = 'section_intro',
  SECTION_IN_PROGRESS = 'section_in_progress',
  SECTION_INCOMPLETE = 'section_incomplete',
  SECTION_COMPLETE = 'section_complete',
}

export enum CertificationStatus {
  INTRO_START = 'intro_start',
  INTRO_VERIFICATION = 'intro_verification',
  INTRO_AGREEMENT = 'intro_agreement',
  INTRO_VIDEO = 'intro_video',
  INTRO_CERTIFICATION_PRE_START = 'intro_certification_pre_start',
  CERTIFICATION_IN_PROGRESS = 'certification_in_progress',
  CERTIFICATION_NPS = 'certification_nps',
  CERTIFICATION_COMPLETE = 'certification_complete',
  CERTIFICATION_INCOMPLETE = 'certification_incomplete',
}

export const CertificationInitialStatus = {
  NOT_STARTED: 'not_started',
} as const;

export type ExtendedCertificationStatus =
  | CertificationStatus
  | (typeof CertificationInitialStatus)[keyof typeof CertificationInitialStatus];

export enum CertificationSectionType {
  MULTIPLE_CHOICE = 'multiple_choice',
  SOC_SIM = 'soc_sim',
  PENTEST_SIM = 'pentest_sim',
}

export enum CertificationType {
  SAL1 = 'SAL1',
  PT1 = 'PT1',
}

export enum CertificationDuration {
  HOURS_24 = '86400000',
  HOURS_48 = '172800000',
}

export enum CertificationExamAvailabilityStatus {
  /** User owns the exam and has at least one attempt available (not in cooldown). */
  AVAILABLE = 'available',
  /** No usable attempt right now: not purchased, attempts exhausted/expired, or cooldown active. */
  UNAVAILABLE = 'unavailable',
  /** An exam attempt is currently active and can be continued. */
  IN_PROGRESS = 'in-progress',
  /** User passed and the certificate remains within its validity window. */
  COMPLETED = 'completed',
  /** User is indefinitely banned from this certification (cannot purchase or attempt). */
  PERMANENTLY_BANNED = 'permanently-banned',
}

export enum CertificationExamVerificationStatus {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILURE = 'fail',
}
